"use client";

import { CheckIcon } from "@heroicons/react/20/solid";

import { ButtonLink } from "@/components/buttons/ButtonLink";
import { TextLink } from "@/components/links/TextLink";
import { NormalText } from "@/components/text/NormalText";
import { OverHeading } from "@/components/text/OverHeading";

export function EnterprisePlan() {
  const sellingPoints = [
    "Use longer training datasets for custom voice models",
    "Improved custom voice model quality",
    "Assistance with voice training",
    "Custom number of voice slots",
    "Access to API",
  ];

  return (
    <div className="mx-auto flex max-w-sm flex-col items-center justify-between rounded-3xl px-4 py-4 shadow-sm ring-1 ring-gray-900/5 sm:px-8 sm:py-8 lg:mx-0 lg:ml-0 lg:mr-0 lg:max-w-none lg:flex-row">
      <div className="mb-5 lg:mb-0 lg:mr-10">
        <OverHeading className="text-gray-900" elementType="h2">
          Enterprise
        </OverHeading>
        <NormalText elementType="p" className="mb-4 max-w-xl">
          We&apos;ll help you fully leverage the application by assisting you in
          training custom voices and teaching you all the tips and tricks to
          achieve the best possible conversions. Contact us at{" "}
          <TextLink
            href="mailto:hi@audimee.com"
            className="text-sm"
            external={true}
          >
            hi@audimee.com
          </TextLink>{" "}
          to get started.
        </NormalText>
        <ButtonLink href="mailto:hi@audimee.com" external={true}>
          Get in touch
        </ButtonLink>
      </div>
      <div>
        <ul className="w-full list-none space-y-3 pl-0 text-sm leading-6 text-gray-600">
          {sellingPoints.map((sellingPoint) => (
            <li key={sellingPoint} className="flex gap-x-2">
              <CheckIcon className="h-5 w-5 flex-none text-primary" />
              <NormalText elementType="span">{sellingPoint}</NormalText>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
